import { Component, Input } from '@angular/core';
import { NgbProgressbarConfig} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress.bar.component.html',
  styleUrls: ['./progress.bar.component.scss']
})
export class ProgressBarComponent {
  allTestsMapping = {
    'RF Pindrop':"3_min" ,
    'RF Continuous':"continuous" ,
    'IPERF':"iperf" ,
    'IPERF Continuous':"iperf_continuous" ,
    'Youtube':"youtube" ,
    'Ping Test':"ping" ,
    'Curl Test':"curl" ,
  };
  max:number
  val:number
  math = Math;
  isAdditional = false;
  formattedMapping={}
  imeiFormattingMap={};
  imeiCopy:any;
  testType:any;
  @Input() set imei(val:any){
         if(val){
          let s = val.split("_");
          this.imeiCopy=s?.[0];
          this.testType = s?.[1];
         }
  }
  @Input() normalLoader:boolean = false;
  @Input() set checkData(val:any){
    console.log(val ,'llllllllllllllllllllllllllllllll');
  }

  
  @Input() set expectedTime(value:any){
   console.log(value);
      if(isNaN(+value)){
        if(value?.[0]=="#"){
          this.max = +value?.substring(1);
          this.isAdditional = true;
        }else{
          this.isAdditional = false;
        }
      }
      this.max = value;
      this.isAdditional = false;
    
          
  }
  @Input() set timePassed(value:number){
    this.val = value
  }

	constructor(private config: NgbProgressbarConfig) {
		// customize default values of progress bars used by this component tree
		config.striped = true;
		config.animated = true;
		config.type = 'success';
		config.height = '3px';
    // config.showValue= true
	}
}
